import tw from 'tailwind-styled-components'

const dialogPanel = `
w-full 
max-w-[687px] 
h-[361px] 
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`

const dialogTitle = `
text-lg 
font-medium 
leading-6 
text-gray-900
flex
justify-between
items-center
`

const Body = tw.div``

const ContentContainer = tw.div`
mt-12
justify-center
items-center
`

export const ButtonsContainer = tw.div`
mt-12
flex 
justify-center
items-center
gap-4
`

export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
px-4
border
border-blueTheme
rounded-lg
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`

export { dialogPanel, dialogTitle, Body, ContentContainer } 